export default () => ({
	allergens: false,
	add(id){
		this.$store.cart.items[id].count ++
	},
	remove(id){
		if(this.$store.cart.items[id].count !== 0){
			this.$store.cart.items[id].count --
		}
	},
	total(){
		return Object.values(this.$store.cart.items).reduce((sum, item) => sum += (item.price * item.count), 0)
	},
	count(){
		return Object.values(this.$store.cart.items).reduce((sum, item) => sum += item.count, 0)
	},
	orderValid(){
		const itemsArr = Object.values(this.$store.cart.items)
		let items = itemsArr.filter(item => item.type === 'boxes').reduce((sum, item) => sum += item.count, 0) >= 5 || itemsArr.filter(item => item.type === 'sets').reduce((sum, item) => sum += item.count, 0) >= 1
		return items
	}
})